import React, { useState } from 'react'
import {
  Button, Title, Spacer, Text
} from 'components/atoms'
import { Modal, Tooltip } from 'components/molecules';
import PropTypes from 'prop-types'
import { useToggle } from 'hooks';
import { insertBlock } from 'services/helpers'

const FormJsonSchema = React.lazy(() => import('components/organisms/FormJsonSchema/FormJsonSchema')
);


const jsonSchema = {
  type: 'object',
  required: [
    'data',
  ],
  properties: {
    data: {
      type: 'array',
      title: 'Slide',
      items: {
        type: 'object',
        required: [
          'src',
          'alt',
          'title'
        ],
        properties: {
          src: {
            title: 'URL da Imagem',
            type: 'string',
          },
          alt: {
            title: 'Texto alternativo',
            type: 'string',
          },
          title: {
            title: 'Legenda',
            type: 'string'
          }
        },
        additionalProperties: false
      }
    }
  },
  additionalProperties: false
}

// generates markdown text by type of entity
const generateTextFromForm = (data) => {
  const picturesArr = data.data.map(picture => `![${picture.alt}](${picture.src} "${picture.title}")`)
  const pictures = picturesArr.join('\n')
  return pictures || ' '
}

export const RichTextEditorOptionCarousel = ({ onChange, editorState, initialValues }) => {
  const [isOpen, toggle] = useToggle();
  const [values, setValues] = useState()

  const handleClick = () => {
    toggle()
  }


  const handleChange = (newProps) => {
    const mergedProps = { ...initialValues, ...newProps }
    setValues(mergedProps)
  }

  const addBlock = () => {
    toggle()
    insertBlock(editorState, onChange, { type: 'CAROUSEL', data: generateTextFromForm(values) })
  }


  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle}>
        <Title>Carousel</Title>
        <Spacer bottom="s">
          <Text>This form is still under development.</Text>
        </Spacer>
        <React.Suspense fallback="Loading">
          <FormJsonSchema
            initialValues={initialValues}
            jsonSchema={jsonSchema}
            onChange={handleChange}
          />
        </React.Suspense>
        <Spacer top="xl">
          <Button
            modifiers={['primary', 'capitalize']}
            onClick={addBlock}
          >
          Concluir
          </Button>
        </Spacer>
      </Modal>
      <Tooltip tooltip="carrossel" placement="bottom">
        <div className="rdw-list-wrapper">
          <Button modifiers={['bgLighterS', 'borderless']} onClick={handleClick}>
            <i aria-label="adicionar carrossel" className="fal fa-images" />
          </Button>
        </div>
      </Tooltip>
    </>
  )
}

RichTextEditorOptionCarousel.propTypes = {
  onChange: PropTypes.func.isRequired,
  editorState: PropTypes.shape({}).isRequired,
  initialValues: PropTypes.shape({}),
}

RichTextEditorOptionCarousel.defaultProps = {
  initialValues: {}
}


export default RichTextEditorOptionCarousel
